export default function useUserConfigTable() {
    return [
      { label: "Indirizzo", key: "descrizione" },
    ];
  }
  